import React from "react";
import {IHCPViewProps} from "../interfaces";
import {HCPUnitView} from "../../HCPDashboardLayout/HCPUnitView/HCPUnitView";

export const FPUnitView = (props: IHCPViewProps) => {
  const {width} = props;

  return <HCPUnitView width={width} />;
};
